import { render, staticRenderFns } from "./label-title.vue?vue&type=template&id=c17b97a8&scoped=true&"
import script from "./label-title.vue?vue&type=script&lang=js&"
export * from "./label-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17b97a8",
  null
  
)

export default component.exports